import React, { type PropsWithChildren, useRef } from 'react';

import { AppContextProvider, type AppContextProviderProps } from '../../../common/ui/app-context';
import {
	type BootstrapContainerProps,
	BootstrapStoreProvider,
} from '../../../controllers/store/bootstrap/bootstrap-store-provider';
import { DropdownStoreContainer } from '../../../controllers/store/dropdown';
import { SearchStoreProvider } from '../../../controllers/store/search/search-store-provider';

import Intercom from './intercom';
import { RegisterHooksWithNewFilters } from './register-hooks';

type ShellProps = PropsWithChildren<BootstrapContainerProps & AppContextProviderProps>;

export const Shell = ({ children, ...props }: ShellProps): React.JSX.Element => {
	const { mapUserIdToProfileUrl, linkComponent, generateSearchUrl, queryParams, onNavigate } =
		props;

	// Ensure callback is stable by using the initial value only
	const mapUserIdToProfileUrlRef = useRef(mapUserIdToProfileUrl);

	return (
		<DropdownStoreContainer>
			<BootstrapStoreProvider {...props}>
				<SearchStoreProvider>
					<Intercom>
						<AppContextProvider
							linkComponent={linkComponent}
							mapUserIdToProfileUrl={mapUserIdToProfileUrlRef.current}
							generateSearchUrl={generateSearchUrl}
							queryParams={queryParams}
							onNavigate={onNavigate}
						>
							<RegisterHooksWithNewFilters>{children}</RegisterHooksWithNewFilters>
						</AppContextProvider>
					</Intercom>
				</SearchStoreProvider>
			</BootstrapStoreProvider>
		</DropdownStoreContainer>
	);
};
